var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineGridEraser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v2c0 .41-.34.75-.75.75s-.75-.34-.75-.75V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h1c.41 0 .75.34.75.75s-.34.75-.75.75H9z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.031 9.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h19.97c.41 0 .75.34.75.75s-.34.75-.75.75H2.031zM2.031 16.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9.97c.41 0 .75.34.75.75s-.34.75-.75.75h-9.97z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76 21.99V2.02c0-.41.34-.75.75-.75s.75.34.75.75v19.97a.749.749 0 1 1-1.5 0zM14.76 11.99V2.02c0-.41.34-.75.75-.75s.75.34.75.75v9.97a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.46 22.14-1.59-1.6c-.81-.81-.81-2.14 0-2.97l1.91-1.9c.29-.29.77-.29 1.06 0l3.5 3.5a.749.749 0 0 1 0 1.06l-1.9 1.9a2.112 2.112 0 0 1-2.98.01zm-.53-3.5a.61.61 0 0 0 0 .85l1.58 1.59c.23.23.62.23.85 0l1.38-1.37-2.44-2.44-1.37 1.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.27 20.23-3.5-3.5a.754.754 0 0 1 0-1.06l2.81-2.82c.82-.82 2.16-.82 2.98 0l1.58 1.59c.39.39.61.92.61 1.49s-.22 1.09-.61 1.49l-2.8 2.81c-.15.15-.34.22-.54.22a.75.75 0 0 1-.53-.22zm.54-1.58 2.27-2.28c.11-.11.17-.26.17-.43 0-.16-.06-.32-.17-.43l-1.58-1.59a.61.61 0 0 0-.85 0l-2.28 2.29 2.44 2.44z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineGridEraser);
export default __webpack_public_path__ + "static/media/vuesax-outline-grid-eraser.ed393a0440dc5721a02b51933e19bb4a.svg";
export { ForwardRef as ReactComponent };